/**
 * The events related to co-review that we receive from RTC server
 */
export enum CatiaCollabEvent {
  CoReview = 'RTCMessengerInviteToCoreview',
  CoReviewStop = 'RTCMessengerCoReviewStop',
  CoReviewLeft = 'RTCMessengerCoReviewLeft',
  CoReviewAccept = 'RTCMessengerReplyToCoreview',
  CoReviewLeadChange = 'RTCMessengerAcceptLead',
  DesignShare = 'RTCMessengerCoDesign',
  SnapShot = 'RTCMessengerSnapShot',
}

/**
 * The event we send to the rich client on click of "Accept" link
 */
export enum CatiaCollabAcceptEvent {
  CoReview = 'CoreviewAccepted',
  DesignShare = 'DesignShareAccepted',
  SnapShot = 'SnapShotAccepted',
  CoReviewStop = '',
}
